<template>
    <div v-if="visible">
        <button type="button" class="text-uppercase filter-button d-flex align-items-center" variant="link" @click="show = true">
            <svg width="16" height="12" viewBox="0 -0.08 9.4800005 6.0701351" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
                <path d="M 0.37000002,3.3301352 H 5.07 a 0.38,0.38 0 1 0 0,-0.75 H 0.37000002 a 0.38,0.38 0 0 0 0,0.75 z"/>
                <path d="M 9.11,2.5801352 H 7.74 a 0.38,0.38 0 0 0 0,0.75 h 1.37 a 0.38,0.38 0 0 0 0,-0.75 z"/>
                <path d="m 4.41,0.67013516 h 4.7 a 0.38,0.38 0 0 0 0.37,-0.38 0.37,0.37 0 0 0 -0.37,-0.37 h -4.7 a 0.37,0.37 0 0 0 -0.38,0.37 0.38,0.38 0 0 0 0.38,0.38 z"/>
                <path d="M 0.37000002,0.67013516 H 1.74 a 0.38,0.38 0 0 0 0.37,-0.38 0.37,0.37 0 0 0 -0.37,-0.37 H 0.37000002 A 0.37,0.37 0 0 0 2.2787972e-8,0.29013516 0.38,0.38 0 0 0 0.37000002,0.67013516 Z"/>
                <path d="m 9.11,5.2401352 h -4.7 a 0.37,0.37 0 0 0 -0.38,0.37 0.38,0.38 0 0 0 0.38,0.38 h 4.7 a 0.38,0.38 0 0 0 0.37,-0.38 0.37,0.37 0 0 0 -0.37,-0.37 z"/>
                <path d="M 1.74,5.2401352 H 0.37000002 A 0.37,0.37 0 0 0 2.2787972e-8,5.6101352 0.38,0.38 0 0 0 0.37000002,5.9901352 H 1.74 a 0.38,0.38 0 0 0 0.37,-0.38 0.37,0.37 0 0 0 -0.37,-0.37 z"/>
            </svg>
            Filtrar
        </button>
        <div class="mobile-filters pt-4 d-flex flex-column">
            <div class="mb-3 px-4 d-flex">
                <b>FILTRAR</b>
                <a href="#" @click="show = false" class="ml-auto text-uppercase"><b>ver resultados</b></a>
            </div>
            <div class="flex-grow-1" style="overflow: auto">
                <div class="px-4 mb-4">
                    <ShoplistFilters :brands="brands" :categories="categories" :variations="variations"/>
                </div>
                <div class="collapse-menu">
                    <MobileFiltersItem title="Marcas">
                        <ProductsFilterBrands :brands="brands" v-if="brands" :header="false"/>
                    </MobileFiltersItem>
                    <MobileFiltersItem v-for="variation in variations" :key="'variation-' + variation.id" :title="variation.name">
                        <ProductsFilterVariation :variation="variation" v-if="variation" :header="false"/>
                    </MobileFiltersItem>
                </div>
            </div>
        </div>
        <div class="mobile-filters-overlay" @click="show = false"></div>
    </div>
</template>

<script>
    import ProductsFilterBrands from "~/components/Products-filter-brands";
    import ProductsFilterAttributes from "~/components/Products-filter-attributes";
    import utils from "~/mixins/utils";
    import ProductsFilterCategories from "~/components/Products-filter-categories";
    import ShoplistFilters from "~/components/Shoplist-filters";
    import ProductsFilterVariations from "~/components/Products-filter-variations";
    import ProductsFilterVariation from "~/components/Products-filter-variation";
    import MobileFiltersItem from "~/components/MobileFiltersItem";

    export default {
        components: {
            ProductsFilterVariation,
            ProductsFilterVariations,
            ShoplistFilters,
            ProductsFilterCategories,
            ProductsFilterAttributes,
            ProductsFilterBrands,
            MobileFiltersItem,
        },
        props: [
            'categories',
            'alias',
            'brands',
            'attributes',
            'variations'
        ],
        head() {
            return {
                bodyAttrs: {
                    class: this.show ? 'mobile-openned-filters' : ''
                }
            }
        },
        mixins: [
            utils
        ],
        data() {
            return {
                show: false
            }
        },
        computed: {
            visible() {
                try {
                    return this.brands.length || this.variations.length
                } catch (e) {
                    console.error(e)
                }
                return false
            }
        }
    }
</script>
